export default __webpack_public_path__ + "static/media/logo.6a1da8f4.svg";